import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);

  useEffect(() => {

    const token = localStorage.getItem("token");
    const email = localStorage.getItem("email");

    if (token && email) {
      setUser({ email });
    }

  }, []);

  const login = (token, email) => {

    localStorage.setItem("token", token);
    localStorage.setItem("email", email);

    setUser({ email });

  };

  const logout = () => {

    localStorage.removeItem("token");
    localStorage.removeItem("email");

    setUser(null);

  };

  return (

    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>

  );

};

export const useAuth = () => useContext(AuthContext);